import { CornersOutIcon, SidebarSimpleIcon } from '@phosphor-icons/react';

import { isTruthy } from 'common';

import { AgenticChatToolbarButton } from './ToolbarButton';
import { useAgenticChatContext } from './context';
import { type AgenticChatViewMode } from '../../GlobalState/context';

interface AgenticChatViewModeButtonProps {
  viewMode: AgenticChatViewMode;
  onToggle: () => void;
}

export function AgenticChatViewModeButton(props: AgenticChatViewModeButtonProps) {
  const { viewMode, onToggle } = props;
  const { isSidebarAvailable } = useAgenticChatContext();

  if (!isTruthy(isSidebarAvailable)) {
    return null;
  }

  return (
    <AgenticChatToolbarButton
      label={viewMode === 'Sidebar' ? 'Expand Flow AI to full screen' : 'Move Flow AI to sidebar'}
      icon={
        viewMode === 'Sidebar' ? (
          <CornersOutIcon />
        ) : (
          <SidebarSimpleIcon style={{ transform: 'scaleX(-1)' }} />
        )
      }
      onClick={() => onToggle()}
    />
  );
}
